import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { purchaseEventFactory } from '@/vendor/gtm/events/ga4/purchase'

export function sendToGA(event: PurchaseEvent): void {
  const dataLayerService = new DataLayerService()

  // 注文が分かれている場合は注文の数だけdataLayer.pushを実行する
  event.orderResultSuccessList.forEach((result) => {
    dataLayerService.push(purchaseEventFactory.createFromOrderResult(result))
  })
}
